// Components
export {
  Alert,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Collapse,
  ConfigProvider,
  DatePicker,
  Descriptions,
  Divider,
  Drawer,
  Dropdown,
  Empty,
  Flex,
  Form,
  Grid,
  Image,
  InputNumber,
  Layout,
  List,
  Menu,
  Modal,
  Pagination,
  Popover,
  Progress,
  Radio,
  Result,
  Segmented,
  Select,
  Skeleton,
  Slider,
  Space,
  Spin,
  Steps,
  Switch,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Typography,
  Upload,
  Row,
  Col,
} from 'antd';

// Types
export type {
  AlertProps,
  AutoCompleteProps,
  AvatarProps,
  BadgeProps,
  BreadcrumbProps,
  ButtonProps,
  CardProps,
  CheckboxProps,
  CollapseProps,
  DatePickerProps,
  DescriptionsProps,
  DividerProps,
  DrawerProps,
  DropdownProps,
  EmptyProps,
  FlexProps,
  FormProps,
  ImageProps,
  InputProps,
  InputNumberProps,
  InputRef,
  LayoutProps,
  ListProps,
  MenuProps,
  ModalProps,
  PaginationProps,
  PopoverProps,
  ProgressProps,
  RadioProps,
  ResultProps,
  SegmentedProps,
  SelectProps,
  SkeletonProps,
  SliderSingleProps,
  SpaceProps,
  SpinProps,
  StepsProps,
  SwitchProps,
  TableProps,
  TabsProps,
  TagProps,
  TooltipProps,
  TypographyProps,
  UploadProps,
  RowProps,
  ColProps,
} from 'antd';
export type { SearchProps, TextAreaProps } from 'antd/es/input';

// Form sub-exports
export type { FormLayout } from 'antd/es/form/Form';
export type { FormInstance } from 'antd/lib/form';

// Sanitized component wrappers — transparent replacements with XSS protection
// Password is NOT sanitized — passwords accept any character and are never rendered as HTML
import { Input as AntdInput, Typography as _AntTypography } from 'antd';
import { SanitizedInput, SanitizedTextArea, SanitizedSearch } from './sanitized-input';

export const Input = Object.assign(SanitizedInput, {
  Password: AntdInput.Password,
  TextArea: SanitizedTextArea,
  Search: SanitizedSearch,
  Group: AntdInput.Group,
  // Per-digit boxes for one-time codes. Not sanitized, and does not need to be:
  // it accepts a fixed count of characters and its value is never rendered as
  // HTML — same reasoning as Password above.
  OTP: AntdInput.OTP,
});

export { SanitizedTextArea, SanitizedSearch } from './sanitized-input';
export { SanitizedAutoComplete as AutoComplete } from './sanitized-autocomplete';

// Typography primitives (prefer over destructuring from Typography)
export { Text } from './text';
export type { TextProps, TextVariant, TextWeight, TextTone, TextFamily } from './text';
export const Title = _AntTypography.Title;
export const Paragraph = _AntTypography.Paragraph;
// antd's styled anchor (distinct from react-router's Link)
export const TextLink = _AntTypography.Link;

// Upload wrapper (bakes dashed-border, bg, padding into antd's Upload.Dragger)
export { UploadDragger } from './upload-dragger/upload-dragger';
export type { UploadDraggerProps } from './upload-dragger/upload-dragger';

// Sub-barrels
export * from './icons';
export * from './notification';
